import React from 'react';
import {
  Button,
  CondensedLarge,
  Form,
  Gutter,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Textarea,
} from '@axiom/ui';
import type { CandidateReputationDetails } from '@axiom/validation';
import { CandidateReputationActions } from '@axiom/const';

import type { ReputationDispute } from '../../schema/reputation-dispute-form-schema';
import { ReputationDisputeFormSchema } from '../../schema/reputation-dispute-form-schema';
import { ActionReputationApi } from '../../api/action-reputation-api';

export type ReputationDetailsDisputeModalProps = {
  onClose: () => void;
  onSubmit: () => Promise<void>;
  disputeData: CandidateReputationDetails;
};

export const ReputationDetailsDisputeModal = ({
  onClose,
  onSubmit,
  disputeData,
}: ReputationDetailsDisputeModalProps) => {
  const handleOnSubmit = async (changedData: Partial<ReputationDispute>) => {
    await ActionReputationApi.createActionReputationDetails({
      reputationId: disputeData.id,
      body: {
        action: CandidateReputationActions.DISPUTED,
        actionNotes: changedData.disputeText ?? null,
      },
    });

    await onSubmit();
  };

  return (
    <Form
      name="DISPUTE_FORM"
      initialValues={{ disputeText: '' }}
      schema={ReputationDisputeFormSchema}
      onSubmit={handleOnSubmit}
    >
      {({ fireSubmit }) => {
        return (
          <Modal name="WRITTEN_DISPUTE_MODAL">
            <ModalHeader
              name="DISPUTE_MODAL_HEADER"
              onClose={() => {
                onClose();
              }}
            >
              Dispute talent feedback
            </ModalHeader>
            <ModalSection>
              <Gutter bottom="16px">
                <CondensedLarge>
                  Please provide your reason for disputing this dispute and we
                  will forward it to the Axiom Talent Experience team.
                </CondensedLarge>
              </Gutter>
              <Textarea
                formatting="modern"
                name="disputeText"
                label="Dispute Reason"
                full
              />
            </ModalSection>
            <ModalFooter>
              <Button
                pattern="primary"
                variation="outline"
                name="CANCEL_BUTTON"
                onClick={() => {
                  onClose();
                }}
              >
                Cancel
              </Button>
              <Button
                pattern="primary"
                name="DISPUTE_BUTTON"
                onClick={() => {
                  void fireSubmit();
                }}
              >
                Dispute Feedback
              </Button>
            </ModalFooter>
          </Modal>
        );
      }}
    </Form>
  );
};
